import { useState } from "react";

const useMainContentWidthManager = () => {
  const [mainContentWidth, setMainContentWidth] = useState("0");

  return [mainContentWidth, setMainContentWidth];
};

export default useMainContentWidthManager;
